import {Links, MappedImage} from "../../utils/fw"

import {UseHeartbeats} from "./HookWrappers"


export const Room = room => {
	const [{
		"First & Last Name": name,
		"Registrant ID": userID,
		"Event Name": eventID,
	}] = window.dataLayer

	const {links, extras, background, ...rest} = room

	return <div style="position: relative" {...rest} path={room.path || room.name.replace(/ /g, "-").replace(/[^A-z-]/g, "")}>
		<UseHeartbeats
			page={room.name}
			data={{eventID, name, userID}}
		/>
		<MappedImage imageURL={background}>
			<Links links={links} roomName={room.name} />
		</MappedImage>
		{extras}
	</div>
}
